import React from 'react';
import styled from 'styled-components';
import { FaUserPlus, FaVoteYea, FaHandHoldingUsd, FaBalanceScale, FaGraduationCap, FaHandsHelping, FaGlobe } from 'react-icons/fa';

const PrincipesPage = () => {
  return (
    <PrincipesContainer>
      <Title>Nos Principes Coopératifs</Title>

      <PrincipleCard>
        <IconWrapper>
          <FaUserPlus />
        </IconWrapper>
        <Content>
          <Subtitle>Adhésion Ouverte</Subtitle>
          <Description>
            Toute personne qui souhaite partager nos valeurs peut devenir membre de notre coopérative.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaVoteYea />
        </IconWrapper>
        <Content>
          <Subtitle>Pouvoir Démocratique</Subtitle>
          <Description>
            Chaque membre participe activement aux décisions grâce au principe <strong>« un membre, une voix »</strong>.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaHandHoldingUsd />
        </IconWrapper>
        <Content>
          <Subtitle>Participation Économique</Subtitle>
          <Description>
            Les membres contribuent équitablement et gèrent ensemble les ressources financières de la coopérative.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaBalanceScale />
        </IconWrapper>
        <Content>
          <Subtitle>Autonomie et Indépendance</Subtitle>
          <Description>
            Nous sommes une organisation indépendante, gérée par et pour nos membres.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaGraduationCap />
        </IconWrapper>
        <Content>
          <Subtitle>Éducation et Formation</Subtitle>
          <Description>
            Nous formons nos membres pour améliorer leurs compétences et les sensibiliser aux valeurs coopératives.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaHandsHelping />
        </IconWrapper>
        <Content>
          <Subtitle>Coopération entre Coopératives</Subtitle>
          <Description>
            Nous collaborons avec d'autres coopératives pour renforcer nos efforts et atteindre nos objectifs.
          </Description>
        </Content>
      </PrincipleCard>

      <PrincipleCard>
        <IconWrapper>
          <FaGlobe />
        </IconWrapper>
        <Content>
          <Subtitle>Engagement Communautaire</Subtitle>
          <Description>
            Nous œuvrons pour un développement durable et un impact positif dans nos communautés.
          </Description>
        </Content>
      </PrincipleCard>
    </PrincipesContainer>
  );
};

// Styles avec styled-components
const PrincipesContainer = styled.div`
  padding: 20px;
  max-width: 1000px;
  margin: auto;
  font-family: 'Arial', sans-serif;
  color: #333;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: #2E8B57;
  margin-bottom: 30px;
  font-size: 2rem;
`;

const PrincipleCard = styled.div`
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: #004080;
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

const Content = styled.div`
  flex: 1;
`;

const Subtitle = styled.h2`
  margin: 0 0 10px;
  color: #2E8B57;
  font-size: 1.4rem;
`;

const Description = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
`;

export default PrincipesPage;
